// IPhoneComponent.tsx

import React from 'react';
import * as S from './styles';

interface IProps {
    src: string;
    active: boolean;
}

const IPhoneComponent: React.FC<IProps> = ({ src, active }) => {
    return (
        <S.IPhoneMockup style={{ display: active ? 'block' : 'none' }}>
            <S.VideoWrapper>
                <video className='video' autoPlay loop preload="auto" muted playsInline>
                    <source src={src} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </S.VideoWrapper>
        </S.IPhoneMockup>
    );
};

export default IPhoneComponent;
